import { CATALOGO, ISENTOS_UNIFICAR_GRUPO } from './permissoes/catalogo';

const PERFIL_NEGOCIADOR = 'NEGOCIADOR';

const temPermissao = (authUserInfo, codigo) =>
  (authUserInfo.permissoes || []).includes(codigo);

const resolverNegociador = (regra, authUserInfo) => {
  if (regra.negociador === undefined) return false;
  if (typeof regra.negociador === 'function')
    return Boolean(regra.negociador(authUserInfo));
  return Boolean(regra.negociador);
};

const resolverRegra = (regra, codigo, authUserInfo) => {
  if (regra.qualquerAcesso)
    return regra.qualquerAcesso.some((filho) =>
      getControleDeAcesso(filho, authUserInfo)
    );

  if (regra.qualquerFlag)
    return regra.qualquerFlag.some((flag) => Boolean(authUserInfo[flag]));

  if (regra.qualquerGranular)
    return regra.qualquerGranular.some((filho) =>
      temPermissao(authUserInfo, filho)
    );

  if (regra.todasFlags)
    return regra.todasFlags.every((flag) => Boolean(authUserInfo[flag]));

  if (regra.flags)
    return regra.flags.some((flag) => Boolean(authUserInfo[flag]));

  if (regra.flag) return Boolean(authUserInfo[regra.flag]);

  if (regra.sempre) return true;

  if (regra.granular || codigo.includes('.'))
    return temPermissao(authUserInfo, codigo);

  return false;
};

export function getControleDeAcesso(codigo, authUserInfo) {
  if (authUserInfo == null) return false;

  const regra = CATALOGO[codigo];

  if (!regra) {
    if (process.env.NODE_ENV !== 'production')
      console.warn(`[acesso] código não cadastrado no catálogo: "${codigo}"`);
    return false;
  }

  if (authUserInfo.perfil === PERFIL_NEGOCIADOR)
    return resolverNegociador(regra, authUserInfo);

  if (authUserInfo.unificar_grupo && !ISENTOS_UNIFICAR_GRUPO.has(codigo))
    return false;

  if (regra.planos && !regra.planos.includes(authUserInfo.plano_empresa))
    return false;

  return resolverRegra(regra, codigo, authUserInfo);
}
